<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'InternalAnnouncementList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <div class="card">
        <div class="card-body">
          <Form
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :application-list="applicationList"
            :tag-options="tagOptions"
            :opportunity-options="opportunityOptions"
            :status-options="statusOptions"
            :values="item"
            :errors="violations"/>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import ApiService from '@/utils/ApiService'
export default {
  name: 'InternalAnnouncementUpdate',
  components: { Form },
  data () {
    return {
      item: {},
      applicationList: [],
      tagOptions: [],
      opportunityOptions: [],
      statusOptions: []
    }
  },
  computed: {
    ...mapGetters({
      violations: 'internalannouncement/update/violations',
      isLoading: 'internalannouncement/update/isLoading',
      updated: 'internalannouncement/update/updated',
      retrieved: 'internalannouncement/update/retrieved'
    }),
    id () {
      return this.$route.params.id
    }
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'InternalAnnouncementList' })
    },
    retrieved (val) {
      this.item = val
    }
  },
  created () {
    this.retrieve(this.id)
    this.getApplicationList()
  },
  methods: {
    ...mapActions({
      update: 'internalannouncement/update/update',
      retrieve: 'internalannouncement/update/retrieve'
    }),
    onSendForm (item) {
      this.update(this.item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    },
    async getApplicationList (internalParams = {}) {
      let params = Object.assign({ pagination: false, disableCheckStatus: 1, state: 1 }, internalParams)
      const response = await new ApiService('applications', params).getResults()
      this.applicationList = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.subdomain
        }
      })
    }
  }
}
</script>
